<app-header></app-header>
<!-- <app-topnav></app-topnav> -->
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->
  <main class="main">
    <!-- Breadcrumb -->
    <ol class="breadcrumb">
      <app-breadcrumbs></app-breadcrumbs>
      <!-- Breadcrumb Menu-->
      <li class="breadcrumb-menu d-md-down-none">
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <a class="btn" href="#"><i class="icon-speech"></i></a>
        </div>
      </li>
    </ol>
    <div class="container-fluid">
      <router-outlet><app-spinner  type="route"></app-spinner></router-outlet>
    </div><!-- /.conainer-fluid -->
    <app-footer></app-footer>
  </main>
 
</div>

<div class="confirmation-overlay"></div>
<div class="overlay"></div>
